var map = {
	"./airbus.png": 65914,
	"./gris-oscuro.jpg": 69461,
	"./iderioja.jpg": 88191,
	"./satelite.jpg": 52736,
	"./street.jpg": 14686,
	"./topografico.jpg": 30752
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76855;